import { useEffect, useRef } from "react";

/**
 * Atajos durante el quiz: 0-6 selecciona; Enter confirma; ← / Retroceso vuelve atrás.
 */
export function useSurveyKeyboard({ enabled, onSelect, onConfirm, onPrev }) {
  const onSelectRef = useRef(onSelect);
  const onConfirmRef = useRef(onConfirm);
  const onPrevRef = useRef(onPrev);
  const submittingRef = useRef(false);

  onSelectRef.current = onSelect;
  onConfirmRef.current = onConfirm;
  onPrevRef.current = onPrev;

  useEffect(() => {
    if (!enabled) return undefined;

    const handleKeyDown = (event) => {
      const tag = event.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;

      const { key } = event;

      if (key >= "0" && key <= "6") {
        event.preventDefault();
        onSelectRef.current(parseInt(key, 10));
        return;
      }

      if (key === "Enter") {
        event.preventDefault();
        if (submittingRef.current) return;
        submittingRef.current = true;
        Promise.resolve(onConfirmRef.current()).finally(() => {
          submittingRef.current = false;
        });
        return;
      }

      if (key === "ArrowLeft" || key === "Backspace") {
        event.preventDefault();
        onPrevRef.current?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [enabled]);
}
